var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-login-layout",
    {
      attrs: { loading: _vm.loading, footer: false, header: false },
      on: { login: _vm.login },
    },
    [
      _c(
        "div",
        {
          staticClass: "logo-holder",
          attrs: { slot: "form-header" },
          slot: "form-header",
        },
        [_c("i", { staticClass: "svg logo-delta-project" })]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }